export const PRESENTLEVELS_EVENT_NAMES = {
  SUMMARY: {
    CLICKED_CATEGORY: 'Clicked Present Levels Category',
    DELETED_AREA: 'Deleted Present Level Area',
    CLICKED_ADD_AREA: 'Clicked Add Present Level Area Button',
    ADDED_AREA: 'Added Present Level Area',
    CLICKED_STANDARD_LINK: 'Clicked Standard Code Link',
    CLEARED_STATEMENT: 'Cleared Statement',
    ADDED_IMPACT_STATEMENT: 'Added Impact Statement in PLW',
    SELECTED_IMPACT_AREA: 'Selected Impact of Disability Impact Area',
    REMOVED_IMPACT_AREA: 'Removed Impact of Disability Impact Area',
    INSERTED_IMPACT_STATEMENT: 'Inserted Impact Statement in PLW',
  },
  LIBRARY_SUMMARY: {
    VIEWED: 'Viewed Drafted Present Levels',
    REMOVED: 'Clicked Remove Present Levels from Library',
  },
  SKILL_SELECTION: {
    CLICKED_SKILL: 'Clicked Present Levels Skill',
    HIGHER_GRADES: 'Clicked View Higher Grade Levels',
    LOWER_GRADES: 'Clicked View Lower Grade Levels',
    GENERATE: 'Generated Present Levels Statement',
    BROWSE_ASSESSMENTS: 'Clicked Browse Assessments in PLW Skills Modal',
  },
  ALIGNED_GOALS: {
    FETCHED: 'Fetched Aligned Goals',
    CLICKED: 'Clicked PLW Aligned Goal',
    BROWSE_MORE: 'Clicked PLW Browse More Goals In',
  },
  NEW_SESSION: {
    VIEWED: 'Viewed Present Levels Wizard',
    SUBMIT: 'Clicked Develop Present Levels',
    RESTART: 'Clicked Restart PLW'
  },
  COMPOSE_IOD: {
    CLICKED: 'Clicked Compose Impact of Disability Statement from Present Levels Wizard'
  },
  RESOURCES: {
    BROWSE_BEHAVIOR_DATA_COLLECTION: 'Clicked PLW Browse Behavior Data Collection Tools',
    MORE_ASSESSMENTS: 'Clicked More Assessments in PLW Resource'
  },
  VIEWED_SHARED_STATEMENT: 'Viewed Shared Present Levels'
}